import { z } from 'zod';

import { findDuplicateIndices } from './find-duplicate-indices';

/**
 * Shared superRefine logic that flags duplicate field values within an array of entities.
 * Skips empty/blank values — two entities with empty fields are NOT considered duplicates.
 *
 * @param fieldExtractor - Function to extract the field string from each entity
 * @param fieldPath - The field path to attach the error to (e.g. 'fullName', 'name', 'email')
 * @param duplicateMessage - The i18n-resolved error message for duplicates
 */
export function duplicateNameRefinement<T>(
  fieldExtractor: (item: T) => string,
  fieldPath: string,
  duplicateMessage: string
) {
  return (items: T[], ctx: z.RefinementCtx) => {
    const values = items.map(item => fieldExtractor(item).trim().toLowerCase());
    const duplicateIndices = findDuplicateIndices(values);

    duplicateIndices.forEach(index => {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: duplicateMessage,
        path: [index, fieldPath],
      });
    });
  };
}
